import React from 'react';
import { useNavigate } from 'react-router-dom';  // Import useNavigate hook
import './CoursesGrid2.css';

// Import images for the courses
import cor1 from '../assets/images/frame/fullstack.jpg';
import cor2 from '../assets/images/frame/pythonds.jpg';
import cor3 from '../assets/images/frame/datacom.jpg';
import cor4 from '../assets/images/frame/dsa.jpg';
import cor5 from '../assets/images/frame/devops.jpg';
import cor6 from '../assets/images/frame/cloud.jpg';
import cor7 from '../assets/images/frame/customized.jpg';  // Image for Basic Office Skills

const courses = [
  {
    id: 1,
    category: "Job Oriented Courses",
    title: "Fullstack Development",
    image: cor1,
    hours: "120 Hours",
    duration: "Spread Across 24 weeks",
    assessments: "18 hrs of assessment",
    projects: "Practice projects",
    // internships: "Internship opportunity upon course completion",
  },
  {
    id: 2,
    category: "Job Oriented Courses",
    title: "Python for Data Science ",
    image: cor2,
    hours: "120 Hours",
    duration: "Spread Across 24 weeks",
    assessments: "18 hrs of assessment",
    projects: "Practice projects",
  },
  {
    id: 3,
    category: "Job Oriented Courses",
    title: "Datacom Networking",
    image: cor3,
    hours: "120 Hours",
    duration: "Spread Across 24 weeks",
    assessments: "18 hrs of assessment",
    projects: "Practice projects",
  },
  {
    id: 4,
    category: "Job Oriented Courses",
    title: "Datastructure & Algorithms",
    image: cor4,
    hours: "120 Hours",
    duration: "Spread Across 24 weeks",
    assessments: "18 hrs of assessment",
    projects: "Practice projects",
  },
  {
    id: 5,
    category: "Job Oriented Courses",
    title: "Devops Engineering",
    image: cor5,
    hours: "120 Hours",
    duration: "Spread Across 24 weeks",
    assessments: "18 hrs of assessment",
    projects: "Practice projects",
  },
  {
    id: 6,
    category: "Job Oriented Courses",
    title: "Cloud Computing",
    image: cor6,
    hours: "120 Hours",
    duration: "Spread Across 24 weeks",
    assessments: "18 hrs of assessment",
    projects: "Practice projects",
  },
  {
    id: 7,
    category: "for Corporates/Individuals",
    title: "Customized Training",
    image: cor7,
    hours: "Hours of training depends on the requirement",
    duration: "Duration is customizable too",
    assessments: "Assessments can be optional",
    // projects: "Practice projects",
  },
];

const CourseGrid2 = () => {
  const navigate = useNavigate();  // Initialize useNavigate hook

  // Handle Apply button click to navigate to the correct route
  const handleApplyClick = (courseId) => {
    if (courseId === 1) {
      // If the course is "Basic Office Skills" (id: 7), navigate to /custing
      navigate('/custing');  // Navigate to Customized Training page
    } else if (courseId === 2){
      navigate('/job-oriented-courses#agile-devops')
    }else {
      // For other courses, navigate to /job-oriented-courses
      navigate('/job-oriented-courses');  // Navigate to Job Oriented Courses page
    }

    // Scroll to the top of the page
    window.scrollTo(0, 0); // Scroll to top
  };

  return (
    <div className="course-grid-2">
      <h1>Job Oriented Courses</h1>
      <div className="courses-container-2">
        {courses.map(course => (
          <div key={course.id} className="course-card-2">
            <img src={course.image} alt={course.title} className="course-image-2" />
            <h3 className="course-title-2">{course.title}</h3>
            <p className="course-category-2">{course.category}</p>
            <p className="course-hours-2">{course.hours}</p>
            <p className="course-duration-2">{course.duration}</p>
            <p className="course-assessments-2">{course.assessments}</p>
            <p className="course-projects-2">{course.projects}</p>
            <p className="course-internships-2">{course.internships}</p>
            <p 
              className="apply-now" 
              onClick={() => handleApplyClick(course.id)} // Call the function with course.id
            >
              Apply Now...
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CourseGrid2;
